/**
 * @memberOf loavies.models.review
 * @constructor
 */
export class ReviewQueryModel {
  /**
   * https://www.sharetribe.com/api-reference/marketplace.html#query-reviews
   * Note that this query requires that exactly one of the parameters transactionId, listingId or subjectId is given.
   * @param {string} [transactionId] Query all reviews posted during given transaction.
   * @param {string} [listingId] Query all reviews about given listing. All reviews about the listing are 'ofProvider' type.
   * @param {string} [subjectId] Query all reviews about given user.
   * @param {string} [type] Either 'ofCustomer' or 'ofProvider'. The query will return only reviews of the given type.
   * @param {string} [state] Comma separated list of review states. The query will return only reviews in the given state.
   */
  constructor({
    transactionId,
    listingId,
    subjectId,
    type,
    state,
  }) {

    /** @type {string} */
    this.transactionId = transactionId

    /** @type {string} */
    this.listingId = listingId

    /** @type {string} */
    this.subjectId = subjectId

    /** @type {string} */
    this.type = type

    /** @type {string} */
    this.state = state
  }
}
